module.exports = __webpack_public_path__ + "img/filter.c6f83c97.svg";